import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IReconTransactions } from '../../interfaces/reconciliation/correspondent/correspondent-recon-transaction.interface';

export abstract class AbstractRtpCorrespondentReconService extends ITableService {
  abstract getReconciliationDetails(
    cycleDate: string,
    reconWindowId: number
  ): Promise<IReconTransactions[] | undefined>;
}
